import { render, staticRenderFns } from "./InputTextMailDialog.vue?vue&type=template&id=361bbf32"
import script from "./InputTextMailDialog.vue?vue&type=script&lang=js"
export * from "./InputTextMailDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports